export default {"src":"/_next/static/media/updater.edac845b.svg","height":25,"width":83,"blurWidth":0,"blurHeight":0};